import { render, staticRenderFns } from "./AttachmentTypeCreate.vue?vue&type=template&id=4c53fd9a&"
import script from "./AttachmentTypeCreate.js?vue&type=script&lang=js&"
export * from "./AttachmentTypeCreate.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports